import { Component, OnDestroy, OnInit } from '@angular/core';
import { NbMediaBreakpointsService, NbMenuService, NbSidebarService, NbThemeService } from '@nebular/theme';
import { map, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

import { AppTranslateService, FilteringService, LayoutService } from '../../../@core/utils';
import { Member } from '../../../@core/models';
import { MemberService } from '../../../@core/data';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'ngx-header',
  styleUrls: ['./header.component.scss'],
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit, OnDestroy {

  currentTheme = 'default';

  member: Member;
  memberFullName;

  themes = [
    {
      value: 'default',
      name: 'Light',
    },
    {
      value: 'dark',
      name: 'Dark',
    },
    {
      value: 'cosmic',
      name: 'Cosmic',
    },
    {
      value: 'corporate',
      name: 'Corporate',
    },
  ];

  userMenu = [{
    title: 'USERMENU.LOGOUT',
    link: '/auth/logout',
    data: {},
  }];
  userPictureOnly = false;

  private destroy$: Subject<void> = new Subject<void>();

  constructor(
    private sidebarService: NbSidebarService,
    private menuService: NbMenuService,
    private themeService: NbThemeService,
    private userService: MemberService,
    private layoutService: LayoutService,
    private breakpointService: NbMediaBreakpointsService,
    private filteringService: FilteringService,
    private appTranslate: AppTranslateService,
    public translateService: TranslateService,
  ) { }

  changeTheme(themeName: string) {
    this.themeService.changeTheme(themeName);
  }

  memberExist() {
    return !!Object.keys(this.member).length;
  }

  navigateHome() {
    this.menuService.navigateHome();
    return false;
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngOnInit() {
    this.currentTheme = this.themeService.currentTheme;

    this.userService.currentUser.pipe(takeUntil(this.destroy$)).subscribe(user => {
      this.member = new Member(user);
      this.memberFullName = this.filteringService
        .toTitleCase(this.member.getFullName());
    });

    const { xl } = this.breakpointService.getBreakpointsMap();

    this.themeService.onMediaQueryChange()
      .pipe(
        map(([, currentBreakpoint]) => currentBreakpoint.width < xl),
        takeUntil(this.destroy$),
      )
      .subscribe((isLessThanXl: boolean) => this.userPictureOnly = isLessThanXl);

    this.themeService.onThemeChange()
      .pipe(
        map(({ name }) => name),
        takeUntil(this.destroy$),
      )
      .subscribe(themeName => this.currentTheme = themeName);

    this.translateService.onLangChange.subscribe((event: LangChangeEvent) => {
      this.appTranslate.translateMenuItems( this.userMenu );
    });
    this.appTranslate.translateMenuItems( this.userMenu );
  }

  toggleSidebar(): boolean {
    this.sidebarService.toggle(true, 'menu-sidebar');
    this.layoutService.changeLayoutSize();

    return false;
  }
}

